// extracted by mini-css-extract-plugin
module.exports = {"sectionwithad":"sRA4h","sliderBlk":"PZvd_","bannerSlider":"_rXMP","fakeLink":"SWr_P"};